import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-modal', 'accept', 'Да');
Labels.set('ui-modal', 'decline', 'Нет');
Labels.set('ui-modal', 'dismiss', 'ОК');
Labels.set('ui-modal', 'close', 'Закрыть всплывающее окно');
Labels.set('ui-modal', 'back', 'Назад');
Labels.set('ui-modal', 'opened', 'Всплывающее окно открыто');
Labels.set('ui-modal', 'exitLabel', 'Нажмите ESC, чтобы закрыть');
